import { TableCell } from "@mui/material";

function SimpleTableHeader(prop) {
  return (
    <TableCell
      className="tableCellHeader" // Add this line to include the CSS class
      align="left"
      style={{
        position: "sticky",
        Top: 0,
        zIndex: 1,
        fontWeight: "bold", // Make Text bold
        padding: "8px", // Adjust padding as needed To make cells smaller
      }}
    >
      {prop}
    </TableCell>
  );
}

export default SimpleTableHeader;
